import React from 'react'

import './index.scss'

const Container = ({ children, ...props }) => (
  <div className="home-container" {...props}>
    {children}
  </div>
)

export default Container
